/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';

import {
  attemptChunkReload,
  clearChunkReloadFlags,
  isChunkLoadError
} from '@lok/utils/lazyWithRetry';

const handleReload = () => {
  clearChunkReloadFlags();
  window.location.reload();
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isStaleChunk: false
    };
  }

  componentDidCatch(error) {
    // Backstop for chunk errors that bypass lazyWithRetry (e.g. CSS chunks,
    // or any future raw React.lazy usage): the shared policy triggers one
    // automatic reload per failing chunk, then lets the error surface here.
    if (attemptChunkReload(error)) {
      return;
    }

    this.setState({
      hasError: true,
      isStaleChunk: isChunkLoadError(error)
    });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.state.isStaleChunk) {
      return (
        <div className='flex h-screen flex-col items-center justify-center gap-4 bg-gray-100 p-8 text-center'>
          <h1 className='text-lg font-bold'>A new version is available</h1>
          <p className='max-w-md text-sm text-gray-600'>
            We just deployed an update and the page you had open is out of
            date. Reload to get the latest version.
          </p>
          <button
            type='button'
            onClick={handleReload}
            className='rounded-xl bg-primary-green px-6 py-2 text-sm font-semibold text-primary-green-fg hover:bg-primary-green/90'
          >
            Reload
          </button>
        </div>
      );
    }

    return (
      <div className='flex h-screen flex-col items-center justify-center gap-4 bg-gray-100 p-8 text-center'>
        <h1 className='text-lg font-bold'>Something went wrong</h1>
        <p className='max-w-md text-sm text-gray-600'>
          An unexpected error occurred. Try reloading the page. If the problem
          persists, contact support.
        </p>
        <button
          type='button'
          onClick={handleReload}
          className='rounded-xl bg-primary-green px-6 py-2 text-sm font-semibold text-primary-green-fg hover:bg-primary-green/90'
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
